import React from 'react';
import { getOptionProperty, nullFn } from '../utils';
import { TagSingleOptionProps, TagOptionRecord } from '../types';
import CrossIcon from '../../../../assets/images/svg/CrossIcon';

function TagSingleOption<T extends TagOptionRecord>({
  option,
  keyField = 'id',
  valueField = 'label',
  onRemoveOption = nullFn,
}: TagSingleOptionProps<T>): JSX.Element {
  const handleOptionRemoved = () => {
    onRemoveOption({
      type: 'REMOVE_SINGLE_OPTION',
      option: option,
      keyField,
      valueField,
    });
  };

  return (
    <div className='relative m-1 flex items-center justify-items-stretch space-x-2 rounded-md bg-green-light leading-none'>
      <div className='py-0.5 pl-3 text-sm font-bold uppercase text-green'>
        {getOptionProperty(option, valueField)}
      </div>

      <button
        type='button'
        onClick={handleOptionRemoved}
        className='flex flex-row items-center justify-center self-stretch py-3 pr-3 text-green outline-none focus:outline-none'
      >
        <CrossIcon strokeWidth='2' />
      </button>
    </div>
  );
}

export default TagSingleOption;
